var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", { attrs: { name: "Listings" } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: { title: "Listings", "with-footer": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "mt-n2 d-flex flex-wrap" },
                            [
                              _c("admin-companies-autocomplete", {
                                staticClass: "mr-2 mt-2",
                                model: {
                                  value: _vm.filters.company,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "company", $$v)
                                  },
                                  expression: "filters.company",
                                },
                              }),
                              _vm._v(" "),
                              _c("b-form-select", {
                                staticClass: "w-auto mr-2 mt-2",
                                attrs: { options: _vm.promoted_filter_options },
                                on: { change: () => _vm.loadListings() },
                                model: {
                                  value: _vm.filters.is_promoted,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "is_promoted", $$v)
                                  },
                                  expression: "filters.is_promoted",
                                },
                              }),
                              _vm._v(" "),
                              _c("b-form-select", {
                                staticClass: "w-auto mr-2 mt-2",
                                attrs: { options: _vm.categoryTypes },
                                on: { change: () => _vm.loadListings() },
                                model: {
                                  value: _vm.filters.category_type,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "category_type", $$v)
                                  },
                                  expression: "filters.category_type",
                                },
                              }),
                              _vm._v(" "),
                              _c("b-form-select", {
                                staticClass: "w-auto mr-2 mt-2",
                                attrs: { options: _vm.statuses },
                                on: { change: () => _vm.loadListings() },
                                model: {
                                  value: _vm.filters.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "status", $$v)
                                  },
                                  expression: "filters.status",
                                },
                              }),
                              _vm._v(" "),
                              _c("b-form-select", {
                                staticClass: "w-auto mr-2 mt-2",
                                attrs: { options: _vm.categories },
                                on: { change: () => _vm.loadListings() },
                                model: {
                                  value: _vm.filters.category,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "category", $$v)
                                  },
                                  expression: "filters.category",
                                },
                              }),
                              _vm._v(" "),
                              _c("b-form-select", {
                                staticClass: "w-auto mr-2 mt-2",
                                attrs: { options: _vm.productionTypes },
                                on: { change: () => _vm.loadListings() },
                                model: {
                                  value: _vm.filters.production_type,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filters,
                                      "production_type",
                                      $$v
                                    )
                                  },
                                  expression: "filters.production_type",
                                },
                              }),
                              _vm._v(" "),
                              _c("b-form-select", {
                                staticClass: "w-auto mt-2",
                                attrs: { options: _vm.strainTypes },
                                on: { change: () => _vm.loadListings() },
                                model: {
                                  value: _vm.filters.strain_type,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "strain_type", $$v)
                                  },
                                  expression: "filters.strain_type",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c("b-pagination", {
                            staticClass: "admin-pagination mb-0",
                            attrs: {
                              "total-rows": _vm.total_in_pages,
                              "per-page": _vm.per_page,
                              align: "center",
                            },
                            on: { change: _vm.loadListings },
                            model: {
                              value: _vm.page,
                              callback: function ($$v) {
                                _vm.page = $$v
                              },
                              expression: "page",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("admin-listings-table", {
                    attrs: { listings: _vm.listings },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }